module.exports = __webpack_public_path__ + "img/flowPath-item2-on.1d8f2934.png";